import * as React from "react";
import './FormPayment.css'
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormStepper from "../../../components/FormStepper/FormStepper";
import {observer} from "mobx-react";
import LottieAnimation from "../../../../../components/LottieAnimation/LottieAnimation";
import {RouteComponentProps} from "react-router";
import FormFinish from "../FormFinish/FormFinish";
import StringUtils from "shared/utils/StringUtils";
// @ts-ignore
import REPLACE_FINISH_IMG from "../../../../../assets/images/thank-you_replace.svg";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import Loader from "../../../../../components/Loader/Loader";
import NavigationConstants from "../../../../Navigation/NavigationConstants";

interface IProps extends RouteComponentProps<any>{
    store: any
}

interface ILocalState {
    formLoading: boolean;
    returnToMyAccount: boolean;
}

const storePropertyName = 'payment';

@observer
export default class FormPayment  extends React.Component<
    IProps, ILocalState> {
    public state: ILocalState = {
        formLoading: true,
        returnToMyAccount: false
    };

    public componentDidMount(): void {
        const {store, history} = this.props;
        if(!store.uid && !store.isInitialized) {
            history.replace(NavigationConstants.myAccount);
        }
        if(!store.formInput[storePropertyName]) {
            store.formInput[storePropertyName] = {
                cardHolderName: '',
                cardNumber: '',
                cardCode: '',
                exiprationMonth: '',
                exiprationYear: '',
            };
        }
        store.navigationController[storePropertyName] = false;
    };

    public getSubTitleText = () => {
        const {store} = this.props;

        if(!store.uid) {
            // Getting here from MyAccount
            if (store.isVerified) {
                return `Your outstanding balance is $${store.getmonthlyPaymentAmount}`
            }
            return "Insert new card details below"
        }
        if(store.formInput.plans && store.formInput.plans.plansValue) {
            if(!store.isVerified) {
                return "Submit a payment method for validation only"
            }
            switch (store.formInput.plans.plansValue) {
                case LeadPlanType.Deposit: return "Your monthly subscription fee is $" + store.getmonthlyPaymentAmount;
                case LeadPlanType.Rent:
                case LeadPlanType.Loan: return (<>
                    <div>Your monthly subscription fee is ${store.getmonthlyPaymentAmount}</div>
                    <div>+ {store.installments} installments of ${StringUtils.toLocalAndFixed(store.monthlyRepayment)} via ACH</div></>);
                case LeadPlanType.DepositRent: return "Submit a payment method for validation only";
            }
        }
        return "Submit a payment method for validation only";

    };

    public render() {
        const {store, history} = this.props;
        if(store.isUpdateCardFinished) {
            return <FormFinish isReplaceCard={true} finishImg={REPLACE_FINISH_IMG} {...this.props}/>
        }

        if(this.state.returnToMyAccount) {
            history.replace(NavigationConstants.myAccount);
        }
        {return store.showFinishPaymentAnimation? this.renderFinishPaymentAnimation(Boolean(store.uid)) : this.renderForm()}
    }

    private renderFinishPaymentAnimation = (isOnSignUpForm: boolean) => {
        if (!isOnSignUpForm) {
            setTimeout(() => {
                const newState = this.state;
                newState.returnToMyAccount = true;
                this.setState(newState);
            }, 5000);
        }
        return (
            <>
                <div className="loading-skate-lottie-container">
                    <LottieAnimation loop={true} animationName={"loading_colors"}/>
                    {isOnSignUpForm? null: <div className="success-payment-text">Your payment method successfully updated</div>}
                </div>
            </>
        );
    }

    private renderForm = () => {
        const {store} = this.props;
        const { formLoading } = this.state;
        if(formLoading) {
            setTimeout(() => {
                const newState = this.state;
                newState.formLoading = false;
                this.setState(newState);
            }, 1500);
        }
        const paymentSteps: any = [
            {
                isHeader: true,
                title: "Payment",
                subTitle: <div className="payment-header-subTitle">{this.getSubTitleText()}</div>,
                inputType: InputTypes.none
            },
            {
                title: "Choose payment method",
                inputType: InputTypes.paymentForm,
                propName: "paymentForm"

            },
        ];
        return (
            formLoading  || store.isSending? <><Loader/></> :
                <>
                    <div className="payment-form-container">
                        <FormStepper store={store} steps={paymentSteps} navigationProperty={storePropertyName}/>
                    </div>
                </>);
    }
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormPayment/FormPayment.tsx